import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

export default function StayInTouch() {
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    // Simulate form submission
    setIsSubmitted(true);
  };

  return (
    <div className="py-16 md:py-24 bg-gray-50 min-h-[80vh] flex items-center">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="bg-white rounded-2xl shadow-xl overflow-hidden flex flex-col md:flex-row"
        >
          {/* Left Panel - About Us & Info */}
          <div className="md:w-5/12 bg-slate-900 text-white p-10 md:p-12 flex flex-col justify-center">
            <h1 className="text-3xl font-extrabold mb-2">World Class Ventures LLC</h1>
            <h2 className="text-xl text-blue-400 font-semibold mb-8">Stay Connected</h2>
            
            <h3 className="text-lg font-bold mb-4 border-b border-slate-700 pb-2">About Us</h3>
            <p className="text-slate-300 leading-relaxed text-sm">
              World Class Ventures LLC is a a company that helps homeowners and business owners educate themselves on mortgages, bookkeeping and getting started in the real estate industry. We provide Customer Care and/or Account Notifications messages. When you consent to receive messaging from World Class Ventures LLC, you are providing it only to World Class Ventures LLC, not any third parties. Your SMS opt-in data will never be shared/sold to third parties.
            </p>
          </div>

          {/* Right Panel - Form Section */}
          <div className="md:w-7/12 p-10 md:p-12">
            {isSubmitted ? (
              <div className="text-center py-16 h-full flex flex-col justify-center items-center">
                <div className="w-16 h-16 bg-green-100 text-green-600 rounded-full flex items-center justify-center mb-6 text-3xl">
                  ✓
                </div>
                <h3 className="text-3xl font-bold text-gray-900 mb-4">Successfully Subscribed!</h3>
                <p className="text-gray-600 mb-8">Thank you for opting in to our SMS updates.</p>
                <button 
                  onClick={() => setIsSubmitted(false)}
                  className="text-blue-600 hover:underline font-medium"
                >
                  Return to form
                </button>
              </div>
            ) : (
              <div>
                <h3 className="text-2xl font-bold text-gray-900 mb-2">Subscribe to SMS Updates</h3>
                <p className="text-gray-600 mb-8">Fill out the form below to get started.</p>

                <form onSubmit={handleSubmit} className="space-y-6">
                  <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
                    <div>
                      <label htmlFor="firstName" className="block text-sm font-medium text-gray-700">First Name *</label>
                      <input 
                        type="text" 
                        id="firstName" 
                        required
                        placeholder="John"
                        className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm px-4 py-3 border"
                      />
                    </div>
                    <div>
                      <label htmlFor="lastName" className="block text-sm font-medium text-gray-700">Last Name *</label>
                      <input 
                        type="text" 
                        id="lastName" 
                        required
                        placeholder="Doe"
                        className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm px-4 py-3 border"
                      />
                    </div>
                  </div>

                  <div>
                    <label htmlFor="email" className="block text-sm font-medium text-gray-700">Email</label>
                    <input 
                      type="email" 
                      id="email" 
                      placeholder="john@example.com"
                      className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm px-4 py-3 border"
                    />
                  </div>

                  <div>
                    <label htmlFor="phone" className="block text-sm font-medium text-gray-700">Phone Number *</label>
                    <input 
                      type="tel" 
                      id="phone" 
                      required
                      placeholder="+1 (555) 123-4567"
                      className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm px-4 py-3 border"
                    />
                  </div>

                  <div className="flex items-start bg-gray-50 p-4 rounded-lg border border-gray-200 mt-6">
                    <div className="flex h-5 items-center">
                      <input
                        id="sms-disclaimer"
                        name="sms-disclaimer"
                        type="checkbox"
                        required
                        className="h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500 mt-1"
                      />
                    </div>
                    <div className="ml-3 text-sm">
                      <label htmlFor="sms-disclaimer" className="text-gray-600 text-xs leading-relaxed">
                        By providing a telephone number, clicking this button, and submitting the form, you are consenting to be contacted by SMS text message from World Class Ventures LLC regarding Customer Care and/or Account Notifications, (our message frequency may vary). Message & data rates apply. Reply STOP to unsubscribe from further messaging from World Class Ventures LLC. Reply HELP for more information. See our <Link to="/privacy" className="text-blue-600 hover:underline">Privacy Policy</Link> (containing our SMS Terms) at the beginning of the page for more information. *
                      </label>
                    </div>
                  </div>

                  <div className="pt-2">
                    <button
                      type="submit"
                      className="w-full flex justify-center py-3.5 px-4 border border-transparent rounded-md shadow-sm text-sm font-bold text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors"
                    >
                      Subscribe Now
                    </button>
                  </div>
                </form>
              </div>
            )}
          </div>
        </motion.div>
      </div>
    </div>
  );
}